import { Component, Input } from '@angular/core';
import { SavedReportView, SavedReportViewReportType } from '../../../../../../models/saved-report-view';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SavedReportViewService } from '../../../../../../services/saved-report-view/saved-report-view.service';


@Component({
  selector: 'app-create-saved-report-view-modal',
  templateUrl: './create-saved-report-view-modal.component.html',
  styleUrls: ['./create-saved-report-view-modal.component.css']
})
export class CreateSavedReportViewModalComponent {
  @Input() reportType: SavedReportViewReportType;
  @Input() columns: string[];
  @Input() filters: any;
  @Input() savedCallback: (createdSrv: SavedReportView) => undefined;

  public name = '';

  public loadingSubmit = false;

  public genericErrorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private savedReportViewService: SavedReportViewService,
  ) {}

  public handleSubmit() {
    this.genericErrorMessage = '';

    const missingRequired = (
      (this.name === '')
    );

    if (missingRequired) {
      this.genericErrorMessage = 'Name is required.';
      return;
    }

    this.loadingSubmit = true;

    this.savedReportViewService
      .addSavedReportView(
        {
          id: null,
          url: '',
          report_type: this.reportType,
          name: this.name,
          columns: this.columns,
          filters: this.filters,
          created_by_id: null,
          created_by_first_name: '',
          created_by_last_name: '',
          created_by_email: '',
          last_updated_by_id: null,
          last_updated_by_first_name: '',
          last_updated_by_last_name: '',
          last_updated_by_email: '',
          created_at: '',
          updated_at: '',
        }
      )
      .then(srv => {
        this.savedCallback(srv);
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.genericErrorMessage = 'Error saving view.'
        } else if (reason.status === 403) {
          this.genericErrorMessage = 'You do not have permission to create this saved view.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
